export default "__VITE_ASSET__377c9bdd__"